import React from 'react';
import '../styles/LoadingIndicator.css';

// Debug control - use i.e. DEBUG && console.log("whatever") and set below const true
const DEBUG = process.env.REACT_APP_DEBUG == 'enabled';

const LoadingIndicator = () => {
  return (
    <div className="loading-container">
      <div className="background-image"></div>
      <div className="loading-content">
        <div className="logo-container">
          <img src={require('../assets/logo.png')} alt="IGEL Logo" className="logo" />
        </div>
        <div className="spinner"></div>
        <p>Loading your IGEL ID profile...</p>
      </div>
    </div>
  );
};

export default LoadingIndicator;